import styled from 'styled-components';
import { Cog } from '@styled-icons/boxicons-regular/Cog';

export const Container = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 1.5rem 0;
    border-top: 0.6rem solid ${({ theme }) => theme.colors.gray8};
    border-bottom: 8px solid #efefef;
  }

  & > header {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;

    & > button > span {
      display: none;
      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: unset;
      }
    }

    & > span {
      font-family: ${({ theme }) => theme.fonts.workSans};
      font-size: 1rem;
      font-weight: 400;
    }
  }
`;

export const CogIcon = styled(Cog)`
  width: 1.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-right: 0.5rem;
  }
`;

export const MessageWrapperChooseItem = styled.div`
  padding-top: 23px;
`;

export const Header = styled.div`
  .hefesto-title {
    padding-top: 16px;
    display: block;
  }

  .hefesto-title h2 {
    font-size: 24px;
    line-height: 33px;
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  span {
    color: #414e55;
  }
`;

export const Message = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
  margin-bottom: 10px;
`;

export const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    border-top: 0.6rem solid ${({ theme }) => theme.colors.gray8};
    padding: 20px 96px 0;
    position: relative;

    &:before {
      content: ' ';
      width: 24px;
      height: 0.6rem;
      position: absolute;
      left: -24px;
      top: -0.6rem;
      background-color: ${({ theme }) => theme.colors.gray8};
    }

    &:after {
      content: ' ';
      width: 24px;
      height: 0.6rem;
      position: absolute;
      right: -24px;
      top: -0.6rem;
      background-color: ${({ theme }) => theme.colors.gray8};
    }
  }

  .hefesto-upload-file__dropzone {
    padding-top: 43px;
    padding-bottom: 27px;
    margin-bottom: 23px;
  }

  .hefesto-button {
    min-height: 48px;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 2rem;

  .hefesto-button {
    padding: 0 33px;
    height: 48px;
  }
`;
